/* File Api Module */
import { requester } from '@/libs/requester';
import { AT } from '@/libs/translation';
import type { FileType } from '../type';

export const FileUploadApi = (file: File) => {
  const formData = new FormData();
  formData.append('image', file);
  return requester.post<FileType>(`/${AT.language}/api/v1/file/image`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
